import React, {Component} from 'react';
import './Contact.css';

class Contact extends Component  {




  render(){
    let {column_1, column_2, column_3} = this.props.doc.data;

    return(
      <div className="Contact">
        <div className="Contact-column" >
          {column_1.map(item => {
            return <div key={item.row} className="Contact-row">{item.row}</div>
          })}
        </div>
        <div className="Contact-column" >
          {column_2.map(item => {
            return <a href={item.link.url} key={item.row} className="Contact-row">{item.row}</a>
          })}
        </div>
        <div className="Contact-column" >
          {column_3.map(item => {
            return <div key={item.row} className="Contact-row">{item.row}</div>
          })}
        </div>
      </div>
    )
  }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.js